if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        // Delegate clicks so dynamically updated thumbnails also work
        this.onThumbnailClick = this.handleThumbnailClick?.bind(this) || ((e) => {});
        this.elements.thumbnails.addEventListener('click', this.onThumbnailClick);
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      disconnectedCallback() {
        try {
          this.elements?.thumbnails?.removeEventListener?.('click', this.onThumbnailClick);
        } catch (e) {}
      }

      handleThumbnailClick(event) {
        const button = event.target.closest('.ms-thumb, [aria-controls^="GalleryViewer-"]');
        if (!button || !this.elements.thumbnails.contains(button)) return;
        const item = button.closest('[data-target]');
        if (!item) return;
        this.setActiveMedia(item.dataset.target, false);
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        const centerActiveMedia = () => {
          const list = activeMedia.parentElement;
          if (!list || list.scrollWidth <= list.clientWidth) return;
          const listRect = list.getBoundingClientRect();
          const itemRect = activeMedia.getBoundingClientRect();
          const currentScroll = list.scrollLeft;
          const target =
            currentScroll + (itemRect.left - listRect.left) - (listRect.width / 2 - itemRect.width / 2);
          const maxScroll = Math.max(0, list.scrollWidth - list.clientWidth);
          const clamped = Math.min(Math.max(target, 0), maxScroll);
          list.scrollTo({ left: clamped, behavior: 'smooth' });
        };

        this.preventStickyHeader();
        requestAnimationFrame(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            centerActiveMedia();
          }
          const rect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (rect.top > -0.5) return;
          const top = rect.top + window.scrollY;
          window.scrollTo({ top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        const list = this.elements.thumbnails.querySelector('[data-thumbs-list]') || this.elements.thumbnails.querySelector('[id^="Slider-Thumbnails"]');
        if (!list) return;
        const useVertical = this.dataset.desktopLayout?.includes('thumbnail') && this.mql.matches;
        if (useVertical) {
          const lastVisible = list.clientHeight + list.scrollTop - 10;
          if (thumbnail.offsetTop + thumbnail.clientHeight > lastVisible || thumbnail.offsetTop < list.scrollTop) {
            list.scrollTo({ top: thumbnail.offsetTop, behavior: 'smooth' });
          }
        } else {
          const lastVisible = list.clientWidth + list.scrollLeft - 10;
          if (thumbnail.offsetLeft + thumbnail.clientWidth > lastVisible || thumbnail.offsetLeft < list.scrollLeft) {
            list.scrollTo({ left: thumbnail.offsetLeft, behavior: 'smooth' });
          }
        }
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
